/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  BulkMoveFolderDocumentsResponseData,
  BulkMoveFolderDocumentsResponseDataFromJSON,
  BulkMoveFolderDocumentsResponseDataFromJSONTyped,
  BulkMoveFolderDocumentsResponseDataToJSON
} from './BulkMoveFolderDocumentsResponseData'

/**
 *
 * @export
 * @interface UpdateChatSummariesRepliedResponse
 */
export interface UpdateChatSummariesRepliedResponse {
  /**
   *
   * @type {number}
   * @memberof UpdateChatSummariesRepliedResponse
   */
  status?: number
  /**
   *
   * @type {BulkMoveFolderDocumentsResponseData}
   * @memberof UpdateChatSummariesRepliedResponse
   */
  data?: BulkMoveFolderDocumentsResponseData
}

export function UpdateChatSummariesRepliedResponseFromJSON(json: any): UpdateChatSummariesRepliedResponse {
  return UpdateChatSummariesRepliedResponseFromJSONTyped(json, false)
}

export function UpdateChatSummariesRepliedResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UpdateChatSummariesRepliedResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : BulkMoveFolderDocumentsResponseDataFromJSON(json['data'])
  }
}

export function UpdateChatSummariesRepliedResponseToJSON(value?: UpdateChatSummariesRepliedResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: BulkMoveFolderDocumentsResponseDataToJSON(value.data)
  }
}
